export enum AssociationTypesEnum {
  FACTORY_CODE = 'FACTORY_CODE',
  PROJECT_CODE = 'PROJECT_CODE',
  COUNTRY = 'COUNTRY'
}
